import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from '../hooks/useTranslation';

const StaySearchBar: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const [city, setCity] = useState('');
    const [hotel, setHotel] = useState('');
    const [checkIn, setCheckIn] = useState('');
    const [checkOut, setCheckOut] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        if (!city && !hotel) {
            setError('يرجى إدخال المدينة أو الفندق');
            return;
        }
        if (!checkIn || !checkOut) {
            setError('يرجى إدخال تواريخ الوصول والمغادرة');
            return;
        }
        if (new Date(checkIn) > new Date(checkOut)) {
            setError('تاريخ الوصول يجب أن يكون قبل تاريخ المغادرة');
            return;
        }

        const params = new URLSearchParams();
        if (city) params.set('city', city);
        if (hotel) params.set('hotel', hotel);
        params.set('checkIn', checkIn);
        params.set('checkOut', checkOut);

        const path = '/search';
        const dest = `${path}?${params.toString()}`;

        if (location.pathname === path) {
            navigate(dest, { replace: false });
        } else {
            navigate(dest);
        }
    };

    return (
        <div className="stay-search-wrapper">
            <div className="container">
                <motion.form
                    className="stay-search-bar"
                    onSubmit={handleSubmit}
                    initial={{ opacity: 0, y: -6 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <div className="field-group">
                        <label className="field-label">المدينة</label>
                        <div className="field-control">
                            <span className="field-icon">📍</span>
                            <input
                                type="text"
                                placeholder="أدخل اسم المدينة"
                                className="field-input"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="field-group">
                        <label className="field-label">الفندق</label>
                        <div className="field-control">
                            <span className="field-icon">🏨</span>
                            <input
                                type="text"
                                placeholder="أدخل اسم الفندق"
                                className="field-input"
                                value={hotel}
                                onChange={(e) => setHotel(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="field-group">
                        <label className="field-label">تاريخ الوصول</label>
                        <div className="field-control">
                            <span className="field-icon">📅</span>
                            <input
                                type="date"
                                className="field-input"
                                value={checkIn}
                                onChange={(e) => setCheckIn(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="field-group">
                        <label className="field-label">تاريخ المغادرة</label>
                        <div className="field-control">
                            <span className="field-icon">📅</span>
                            <input
                                type="date"
                                className="field-input"
                                value={checkOut}
                                onChange={(e) => setCheckOut(e.target.value)}
                            />
                        </div>
                    </div>

                    <motion.button
                        type="submit"
                        className="btn btn-primary search-submit"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                    >
                        بحث
                    </motion.button>
                </motion.form>
                {error && (
                    <motion.div
                        className="search-error"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                    >
                        {error}
                    </motion.div>
                )}
            </div>
        </div>
    );
};

export default StaySearchBar;
